import type { ChipFamilyType } from './Families'

export function updateFamilies(previousState: ChipFamilyType[], selectedFamily: ChipFamilyType) {
  const isFamilyAlreadySelected = previousState.some(
    familySelected => familySelected.id === selectedFamily.id,
  )
  return isFamilyAlreadySelected
    ? previousState.filter(
        familySelected => familySelected.id !== selectedFamily.id,
      )
    : [...previousState, selectedFamily]
}
